export default "__VITE_ASSET__DiepZ9a1__";